import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GuestModeService {
  private guestModeSubject = new BehaviorSubject<boolean>(false);
  public guestMode$: Observable<boolean> = this.guestModeSubject.asObservable();

  constructor() {}

  setGuestMode(isGuest: boolean): void {
    this.guestModeSubject.next(isGuest);
  }

  isGuestMode(): boolean {
    return this.guestModeSubject.value;
  }
}
